import React, { useContext, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { FC } from "react";

import { QESButton, QESRadioButton } from "@app/shared/qes-standards";
import { AdequacyQueryShape } from "@app/projects/CountyProjectContainer";
import { FlyoutContext } from "@app/shared/Flyouts";
import { querystringify, parseQuerystring } from "@app/shared/utility";
import { ChangedGapsEnum } from "../enumerators";

const ChangedGapsFilter: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const actionMenuContext = useContext(FlyoutContext);

  const [allChangedGaps, setAllChangedGaps] = useState(true);
  const [closedGaps, setClosedGaps] = useState(false);
  const [openedGaps, setOpenedGaps] = useState(false);

  const updateQuery = () => {
    if (!allChangedGaps && !closedGaps && !openedGaps) {
      return;
    }

    let query = parseQuerystring(location.search) as AdequacyQueryShape;

    if (allChangedGaps) {
      query = {
        ...query,
        all: "false",
        changedGaps: ChangedGapsEnum.All,
        exceptions: "false",
        gaps: "false",
      }
    } else if (closedGaps) {
      query = {
        ...query,
        all: "false",
        changedGaps: ChangedGapsEnum.Closed,
        exceptions: "false",
        gaps: "false",
      }
    } else if (openedGaps) {
      query = {
        ...query,
        all: "false",
        changedGaps: ChangedGapsEnum.Opened,
        exceptions: "false",
        gaps: "false",
      }
    }

    const qs = querystringify(query as { [key: string]: unknown });
    history.push({
      ...history.location,
      search: qs,
    });
    actionMenuContext.handleCloseFlyout();
  }

  return (
    <>
      <div className="col-12 mb20">
        <QESRadioButton
          label="All Changed Gaps"
          onChange={
            (e) => {
              if (e.target.checked && !allChangedGaps) {
                setAllChangedGaps(true);
                setOpenedGaps(false);
                setClosedGaps(false);
              }
              else {
                setAllChangedGaps(false);
              }
            }
          }
          checked={allChangedGaps}
          testId="all-changed-gaps-filter__current-service-area"
          name="all-changed-gaps-type"
        />
        <QESRadioButton
          label="Opened Gaps"
          onChange={
            (e) => {
              if (e.target.checked && !openedGaps) {
                setAllChangedGaps(false);
                setOpenedGaps(true);
                setClosedGaps(false);
              }
              else {
                setOpenedGaps(false);
              }
            }
          }
          checked={openedGaps}
          testId="opened-gaps-filter__current-service-area"
          name="opened-gaps-type"
        />
        <QESRadioButton
          label="Closed Gaps"
          onChange={
            (e) => {
              if (e.target.checked && !closedGaps) {
                setAllChangedGaps(false);
                setOpenedGaps(false);
                setClosedGaps(true);
              }
              else {
                setClosedGaps(false);
              }
            }
          }
          checked={closedGaps}
          testId="closed-gaps-filter__current-service-area"
          name="closed-gaps-type"
        />
      </div>
      <div className="px-1">
        <QESButton qesType="primary" qesTestId="changed-gaps-filter__apply" onClick={updateQuery} className="col-12">
          Apply
        </QESButton>
      </div>
    </>
  );
};

export default ChangedGapsFilter;
